
import { COMMON } from '@/api'
import wx from 'weixin-js-sdk'

export default {
    data() {
        return {
            __emitChat: false
        }
    },
    methods: {
        actionSeekHelp(Position = 'Ask') {  // 跳转Debug页面

            // 非微信环境 不跳转Debug 提示微信环境中打开
            if (localStorage.AUTH_TYPE !== 'WECHAT') {
                location.href = 'http://open.weixin.qq.com/connect/oauth2/authorize?appid=appid'
                return
            }

            // 苹果设备 主要是Mac企微 Ios微信/企微
            const AppleDevice = !!navigator.userAgent.match(/Mac OS X/ig) || !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
            // Position与配置文件中URL的mapping关系
            const MappingData = {
                Ask: 'DebugTicketCreateURL',
                Fixed: 'DebugTicketCreateURL',
                Search: 'DebugTicketCreateURL',
                Mine: 'DebugTicketListURL'
            }
            // 临时存储的 URL String
            const TempURL = process.env[MappingData[Position]]
            // 需要跳转的地址
            let DebugAuthURL = null

            if (!this.localDataNull('Help_Debug_AuthAppId') && !this.localDataNull('Help_Debug_AuthSign')) {  // local中有数据 未被删除
                DebugAuthURL = TempURL.split('#')[0] + '?action=help&ad=' + localStorage.ADAccount + '&appId=' + localStorage.Help_Debug_AuthAppId + '&sign=' + localStorage.Help_Debug_AuthSign + '#' + TempURL.split('#')[1]
            } else {  // 没有local数据 直接跳转 不添加鉴权参数
                DebugAuthURL = TempURL
            }

            
            if (!AppleDevice) {
                // 后端通过获取url后面参数 没有取data参数
                navigator.sendBeacon(process.env.apiHost + '/Statistics/AddDebugClickViewData?Token=' + localStorage.token + '&ADAccount=' + localStorage.ADAccount + '&TimeStamp=' + +new Date() + '&Position=' + Position, 'Some data not used by the backend...')
                location.replace(DebugAuthURL)
            } else {
                // 降级处理
                COMMON.DebugSeekHelp({
                    Position: Position
                }).then( (res) => {
                    location.replace(DebugAuthURL)
                }).catch( (err) => {
                    location.replace(DebugAuthURL)
                })

                // 防止接口响应时间过长 强制跳转
                let timer = setTimeout( () => {
                    location.replace(DebugAuthURL)
                    clearTimeout(timer)
                }, 100)
            }
        },
        actionEnterpriseChat(title, ownerName, chatList) { // 点击企微创建会话按钮
            
            console.log('chatList: ', chatList)

            // 数据埋点
            COMMON.enterpriseChat({
                KBInfoId: this.$route.params.uuid,
                KBName: title,
                ChatUser: localStorage.ADAccount,
                OwnerName: ownerName
            }).then(() => {})

            // 创建会话
            this.actionChat(chatList)
        },
        actionChat(chatList) { // 打开企业微信群聊
            if (localStorage.AUTH_TYPE !== 'WECHAT') {
                alert('请在企业微信中打开')
                return
            }
            if (!chatList || chatList.length === 0) {
                alert('创建失败，参与会话人员列表为空')
                return
            }
            wx.openEnterpriseChat({
                userIds: chatList.join(';'),
                groupName: '会话-来自Help知识库',
                success: function (res) {
                    console.log('--会话创建成功--', res)
                },
                fail: function (res) {
                    if (res.errMsg.indexOf('function not exist') > -1) {
                        alert('创建失败，版本过低请先升级')
                    }
                    alert(res.errMsg)
                }
            })
        },
        localDataNull(propertyName) { // 检测某个local数据是否存在
            return localStorage[propertyName] === undefined
        }
    }
}


// WEBPACK FOOTER //
// ./src/utils/commonMixin.js